import en from '@/texts/en'
import fr from '@/texts/fr'

export default { en, fr }